var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_571_22169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.34196 3.19441L6.35261 3.1873L6.36289 3.17965C9.24238 1.036 12.61 0.328452 15.7064 0.537068C18.0199 0.692942 20.1576 1.3586 21.8036 2.29505C19.9172 2.27663 18.3272 2.75148 17.0047 3.58026C15.2658 4.66996 14.0341 6.34299 13.1883 8.19924C11.601 11.6829 11.3213 15.9227 11.6674 18.5774C8.33513 19.2882 5.84084 18.8216 4.07188 17.7966C2.24664 16.7391 1.1398 15.0566 0.679018 13.3235C0.682166 13.277 0.687436 13.2081 0.69592 13.1191C0.71353 12.9344 0.744951 12.6632 0.799875 12.3248C0.909823 11.6474 1.11337 10.7041 1.48689 9.64758C2.23484 7.53192 3.65399 4.9891 6.34196 3.19441Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.84286 28.2797L8.83137 28.2741L8.81961 28.269C5.5203 26.8589 3.26623 24.2857 1.94279 21.4859C0.948414 19.3823 0.489687 17.1722 0.5002 15.2657C1.43184 16.914 2.65026 18.0519 4.04548 18.7767C5.87091 19.7249 7.95186 19.9416 9.99843 19.7346C13.8419 19.3459 17.6896 17.4506 19.8259 15.823C22.1099 18.3407 22.9403 20.7054 22.9247 22.7219C22.9087 24.8045 21.9902 26.584 20.7084 27.8508C20.7074 27.8513 20.7064 27.8518 20.7054 27.8524C20.6615 27.8748 20.5948 27.9082 20.5068 27.9503C20.3308 28.0343 20.07 28.1526 19.7373 28.2861C19.0712 28.5535 18.1202 28.8805 16.986 29.1174C14.713 29.592 11.7407 29.6977 8.84286 28.2797Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4039 13.3742L29.4047 13.3871L29.4063 13.3999C29.8303 16.9549 28.7738 20.1756 27.0585 22.7036C25.7746 24.5959 24.1334 26.0827 22.4962 27.0229C23.4576 25.4052 23.8389 23.8004 23.7756 22.2513C23.6924 20.2177 22.8457 18.336 21.6481 16.6967C19.4 13.6198 15.8419 11.2949 13.363 10.2716C14.4109 7.04456 16.0627 5.1277 17.8377 4.11469C19.6704 3.06878 21.688 2.9551 23.4268 3.42476C23.4658 3.45077 23.5233 3.48991 23.5968 3.54203C23.7487 3.64963 23.9689 3.81238 24.2357 4.02902C24.77 4.4627 25.4885 5.11002 26.2205 5.9606C27.6864 7.66399 29.1875 10.1593 29.4039 13.3742Z",
    fill: "white",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_571_22169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppium);
export default __webpack_public_path__ + "static/media/appium.567afd82f67f9d5db067b507311bcfbf.svg";
export { ForwardRef as ReactComponent };